/* globals lp,Class */
var ubBanzai = require('ub/control/banzai-features');
var isSandboxMode = ubBanzai.features.isSandboxEnabled();

var CustomeHTMLModule = Class.create(
  lp.ModuleBase,
  lp.ModuleElementMethods,
  lp.ModuleElementBuilderMethods,
  lp.ModuleElementPropertiesPanelMethods,
  {
    beforeCreate: function (page, defaults, options, data) {
      defaults.content.html = data.html;
      defaults.content.valid = data.valid;
      defaults.content.errors = data.errors;
    }
  }
);

lp.addModule(new CustomeHTMLModule(
  {
    type:'lp-code',
    isAllowedOnPage: function(page) {
      return page.getConfigValue('allowCodeWidget');
    },
    getLimit: function() {
      return isSandboxMode ? 0 : Infinity;
    },
    version:'1.0',
    name: 'Custom HTML',
    usageType:'page-widget',
    namespace: lp.module.code
  }
));

module.exports = CustomeHTMLModule;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-code/code_module.js
// module id = 582
// module chunks = 0 1